module.exports = function getResource(label, vars = []) {
    const resources = { new: 'NEW' };

    return resources[label];
};
